import React from 'react'
import { FormProvider } from 'react-hook-form'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { CreateFilesForm } from './CreateFilesForm'
import { useCreateFilesForm } from './useCreateFilesForm'

interface ICreateFilesProps extends Omit<IModalBaseProps, 'modalType'> {}

export const CreateFiles = ({ onClose, open = false, ...props }: ICreateFilesProps) => {
  const methods = useCreateFilesForm({
    defaultValues: {
      shipmentId: '',
      appointmentUpdates: false,
      stopUpdates: false,
    },
  })

  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Close',
      action: onClose,
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
  ]

  return (
    <ModalBase
      dataTest='CreateFilesTest'
      modalType={MODAL_TYPES.form}
      size={8}
      open={open}
      actions={actions}
      onClose={onClose}
      {...props}>
      <FormProvider {...methods}>
        <CreateFilesForm />
      </FormProvider>
    </ModalBase>
  )
}
